const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10.27 18.16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.53,8c-2.29-.6-3-1.21-3-2.17s1-1.87,2.73-1.87,2.46.86,2.52,2.12H10A4,4,0,0,0,6.74,2.21V.72A.73.73,0,0,0,6,0H4.44a.73.73,0,0,0-.73.72V2.18C1.76,2.6.18,3.87.18,5.82.18,8.15,2.11,9.31,4.92,10c2.53.61,3,1.49,3,2.43,0,.7-.49,1.81-2.72,1.81s-2.9-.93-3-2.12H0C.12,14.32,1.78,15.56,3.71,16v1.46a.73.73,0,0,0,.73.73H6a.73.73,0,0,0,.73-.73V16c2-.37,3.53-1.51,3.53-3.58C10.27,9.54,7.82,8.57,5.53,8Z",
    style: {
      fill: "#ccc"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.0bd13aace6365f01b4e9e27c7c88c2ab.svg";
export { ForwardRef as ReactComponent };